import React, { useRef } from 'react';
var VeltNotificationsPanelTitle = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-title", { ref: ref }, children));
};
export default VeltNotificationsPanelTitle;
